export enum MODULES_ENUM {
  CONSTRUCTING = "constructing",
  OBJECTS = "objects",
  PURCHASES = "purchases",
  TASKS = "tasks"
}